// @generated by protoc-gen-es v1.10.1
// @generated from file rbt/cloud/v1alpha1/organization/organization.proto (package rbt.cloud.v1alpha1.organization, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp, Value } from "@bufbuild/protobuf";
import { ApplicationSize } from "../application/application_pb.js";

/**
 * @generated from enum rbt.cloud.v1alpha1.organization.Role
 */
export const Role = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.organization.Role",
  [
    {no: 0, name: "VIEWER"},
    {no: 1, name: "EDITOR"},
    {no: 2, name: "OWNER"},
  ],
);

/**
 * @generated from enum rbt.cloud.v1alpha1.organization.GracePeriodStage
 */
export const GracePeriodStage = /*@__PURE__*/ proto3.makeEnum(
  "rbt.cloud.v1alpha1.organization.GracePeriodStage",
  [
    {no: 0, name: "STARTED"},
    {no: 1, name: "REMINDER"},
    {no: 2, name: "FINAL_WARNING"},
    {no: 3, name: "EXPIRED"},
    {no: 4, name: "RESOLVED"},
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.OrganizationMember
 */
export const OrganizationMember = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.OrganizationMember",
  () => [
    { no: 1, name: "role", kind: "enum", T: proto3.getEnumType(Role) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.PendingInvite
 */
export const PendingInvite = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.PendingInvite",
  () => [
    { no: 1, name: "role", kind: "enum", T: proto3.getEnumType(Role) },
    { no: 2, name: "invited_at", kind: "message", T: Timestamp },
    { no: 3, name: "invited_by_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.Subscription
 */
export const Subscription = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.Subscription",
  () => [
    { no: 1, name: "pending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "customer_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "client_secret", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "card", kind: "message", T: Card, opt: true },
    { no: 7, name: "payment_method_timestamp", kind: "message", T: Timestamp },
    { no: 8, name: "credit_balance_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "credit_ever_granted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "grace_period_started_at", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "grace_period_expires_at", kind: "message", T: Timestamp, opt: true },
    { no: 13, name: "open_invoices", kind: "message", T: OpenInvoice, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.OpenInvoice
 */
export const OpenInvoice = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.OpenInvoice",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "amount_due_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.Card
 */
export const Card = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.Card",
  () => [
    { no: 1, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "exp_month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "exp_year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.OrganizationApplication
 */
export const OrganizationApplication = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.OrganizationApplication",
  () => [
    { no: 1, name: "latest_revisions_size", kind: "enum", T: proto3.getEnumType(ApplicationSize), opt: true },
    { no: 2, name: "billed_size", kind: "enum", T: proto3.getEnumType(ApplicationSize), opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscriptionItem
 */
export const SubscriptionItem = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscriptionItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.Organization
 */
export const Organization = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.Organization",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "members", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: OrganizationMember} },
    { no: 3, name: "created_at_timestamp", kind: "message", T: Timestamp },
    { no: 4, name: "pending_invites_by_email", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: PendingInvite} },
    { no: 5, name: "applications", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: OrganizationApplication} },
    { no: 6, name: "subscription", kind: "message", T: Subscription },
    { no: 9, name: "subscription_items", kind: "map", K: 5 /* ScalarType.INT32 */, V: {kind: "message", T: SubscriptionItem} },
    { no: 10, name: "pending_webhook_events", kind: "message", T: Value, repeated: true },
    { no: 11, name: "pinned_qualified_application_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "billing_exempt", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "redeemed_credit_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.CreateRequest
 */
export const CreateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.CreateRequest",
  () => [
    { no: 1, name: "organization_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subscribe", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.CreateResponse
 */
export const CreateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.CreateResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.AddMemberRequest
 */
export const AddMemberRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.AddMemberRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(Role) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.AddMemberResponse
 */
export const AddMemberResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.AddMemberResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.RemoveMemberRequest
 */
export const RemoveMemberRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.RemoveMemberRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.RemoveMemberResponse
 */
export const RemoveMemberResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.RemoveMemberResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateMemberRequest
 */
export const UpdateMemberRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateMemberRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(Role) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateMemberResponse
 */
export const UpdateMemberResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateMemberResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.InviteMemberRequest
 */
export const InviteMemberRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.InviteMemberRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(Role) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.InviteMemberResponse
 */
export const InviteMemberResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.InviteMemberResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.CancelInviteRequest
 */
export const CancelInviteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.CancelInviteRequest",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.CancelInviteResponse
 */
export const CancelInviteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.CancelInviteResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.AcceptInviteRequest
 */
export const AcceptInviteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.AcceptInviteRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.AcceptInviteResponse
 */
export const AcceptInviteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.AcceptInviteResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GetPendingInvitesRequest
 */
export const GetPendingInvitesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GetPendingInvitesRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GetPendingInvitesResponse
 */
export const GetPendingInvitesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GetPendingInvitesResponse",
  () => [
    { no: 1, name: "pending_invites", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: PendingInvite} },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.OrganizationMemberView
 */
export const OrganizationMemberView = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.OrganizationMemberView",
  () => [
    { no: 1, name: "role", kind: "enum", T: proto3.getEnumType(Role) },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GetMembersRequest
 */
export const GetMembersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GetMembersRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GetMembersResponse
 */
export const GetMembersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GetMembersResponse",
  () => [
    { no: 1, name: "members", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: OrganizationMemberView} },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GetRequest
 */
export const GetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GetRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GetResponse
 */
export const GetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GetResponse",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "qualified_application_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.ListApplicationsRequest
 */
export const ListApplicationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.ListApplicationsRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.ApplicationSummary
 */
export const ApplicationSummary = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.ApplicationSummary",
  () => [
    { no: 2, name: "application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "qualified_application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.ListApplicationsResponse
 */
export const ListApplicationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.ListApplicationsResponse",
  () => [
    { no: 1, name: "applications", kind: "message", T: ApplicationSummary, repeated: true },
    { no: 2, name: "pinned_qualified_application_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.PinApplicationRequest
 */
export const PinApplicationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.PinApplicationRequest",
  () => [
    { no: 1, name: "qualified_application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.PinApplicationResponse
 */
export const PinApplicationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.PinApplicationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UnpinApplicationRequest
 */
export const UnpinApplicationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UnpinApplicationRequest",
  () => [
    { no: 1, name: "qualified_application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UnpinApplicationResponse
 */
export const UnpinApplicationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UnpinApplicationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.AddApplicationRequest
 */
export const AddApplicationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.AddApplicationRequest",
  () => [
    { no: 1, name: "qualified_application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.AddApplicationResponse
 */
export const AddApplicationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.AddApplicationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.RemoveApplicationRequest
 */
export const RemoveApplicationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.RemoveApplicationRequest",
  () => [
    { no: 1, name: "qualified_application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.RemoveApplicationResponse
 */
export const RemoveApplicationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.RemoveApplicationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscribeRequest
 */
export const SubscribeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscribeRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscribeResponse
 */
export const SubscribeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscribeResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SetBillingExemptRequest
 */
export const SetBillingExemptRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SetBillingExemptRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SetBillingExemptResponse
 */
export const SetBillingExemptResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SetBillingExemptResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.DetachFromStripeWorkflowRequest
 */
export const DetachFromStripeWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.DetachFromStripeWorkflowRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.DetachFromStripeWorkflowResponse
 */
export const DetachFromStripeWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.DetachFromStripeWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscribeWorkflowRequest
 */
export const SubscribeWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscribeWorkflowRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscribeWorkflowResponse
 */
export const SubscribeWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscribeWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscriptionRequest
 */
export const SubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscriptionRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.SubscriptionResponse
 */
export const SubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.SubscriptionResponse",
  () => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
    { no: 2, name: "billing_exempt", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.RedeemCreditCodeRequest
 */
export const RedeemCreditCodeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.RedeemCreditCodeRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.RedeemCreditCodeResponse
 */
export const RedeemCreditCodeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.RedeemCreditCodeResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GrantCreditWorkflowRequest
 */
export const GrantCreditWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GrantCreditWorkflowRequest",
  () => [
    { no: 1, name: "amount_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.GrantCreditWorkflowResponse
 */
export const GrantCreditWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.GrantCreditWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.NotifyCreditDepletionRequest
 */
export const NotifyCreditDepletionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.NotifyCreditDepletionRequest",
  () => [
    { no: 1, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.NotifyCreditDepletionResponse
 */
export const NotifyCreditDepletionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.NotifyCreditDepletionResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateSubscriptionRequest
 */
export const UpdateSubscriptionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateSubscriptionRequest",
  () => [
    { no: 1, name: "subscription", kind: "message", T: Subscription },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateSubscriptionResponse
 */
export const UpdateSubscriptionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateSubscriptionResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.BeginGracePeriodRequest
 */
export const BeginGracePeriodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.BeginGracePeriodRequest",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "invoice", kind: "message", T: OpenInvoice, opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.BeginGracePeriodResponse
 */
export const BeginGracePeriodResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.BeginGracePeriodResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.EndGracePeriodRequest
 */
export const EndGracePeriodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.EndGracePeriodRequest",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paid_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.EndGracePeriodResponse
 */
export const EndGracePeriodResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.EndGracePeriodResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.EnforceGracePeriodExpiryRequest
 */
export const EnforceGracePeriodExpiryRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.EnforceGracePeriodExpiryRequest",
  () => [
    { no: 1, name: "deadline", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.EnforceGracePeriodExpiryResponse
 */
export const EnforceGracePeriodExpiryResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.EnforceGracePeriodExpiryResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.NotifyGracePeriodRequest
 */
export const NotifyGracePeriodRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.NotifyGracePeriodRequest",
  () => [
    { no: 1, name: "stage", kind: "enum", T: proto3.getEnumType(GracePeriodStage) },
    { no: 2, name: "invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.NotifyGracePeriodResponse
 */
export const NotifyGracePeriodResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.NotifyGracePeriodResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.NotifyTeamRequest
 */
export const NotifyTeamRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.NotifyTeamRequest",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.NotifyTeamResponse
 */
export const NotifyTeamResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.NotifyTeamResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.EnqueueWebhookEventRequest
 */
export const EnqueueWebhookEventRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.EnqueueWebhookEventRequest",
  () => [
    { no: 1, name: "event", kind: "message", T: Value },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.EnqueueWebhookEventResponse
 */
export const EnqueueWebhookEventResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.EnqueueWebhookEventResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateApplicationRequest
 */
export const UpdateApplicationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateApplicationRequest",
  () => [
    { no: 1, name: "qualified_application_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "size", kind: "enum", T: proto3.getEnumType(ApplicationSize) },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateApplicationResponse
 */
export const UpdateApplicationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateApplicationResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateCardRequest
 */
export const UpdateCardRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateCardRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateCardResponse
 */
export const UpdateCardResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateCardResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateCardWorkflowRequest
 */
export const UpdateCardWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateCardWorkflowRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.UpdateCardWorkflowResponse
 */
export const UpdateCardWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.UpdateCardWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.StripeWebhookWorkflowRequest
 */
export const StripeWebhookWorkflowRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.StripeWebhookWorkflowRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.StripeWebhookWorkflowResponse
 */
export const StripeWebhookWorkflowResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.StripeWebhookWorkflowResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.ReconcileWithStripeRequest
 */
export const ReconcileWithStripeRequest = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.ReconcileWithStripeRequest",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.ReconcileWithStripeResponse
 */
export const ReconcileWithStripeResponse = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.ReconcileWithStripeResponse",
  [],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.InvalidInputError
 */
export const InvalidInputError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.InvalidInputError",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message rbt.cloud.v1alpha1.organization.InvalidOperationError
 */
export const InvalidOperationError = /*@__PURE__*/ proto3.makeMessageType(
  "rbt.cloud.v1alpha1.organization.InvalidOperationError",
  () => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

